export const menuEntryActiveIndicatorWidth = '3px'
